module.exports = __webpack_public_path__ + "static/spalyed.3edc40ff.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/spalyed.svg
// module id = 453
// module chunks = 35783957827783 172322841747965